define('view/form/attachment.point.content.view',['require','exports','module','backbone.radio','uikit/uikit','blockit','formkit/formkit','uuid','datakit/datakit','fukit','model/template.object.attachment.model','behavior/select.and.upload.files.behavior','behavior/download.file.on.event.behavior','behavior/drag.and.drop.files.behavior','fukit','fukit'],function(require, exports, module) {
  //prettier-ignore
  var Radio                         = require('backbone.radio'),
      UIKit                         = require('uikit/uikit'),
      BlocKit                       = require('blockit'),
      FormKit                       = require('formkit/formkit'),
      UUID                          = require('uuid'),
      urlTemplate                   = require('datakit/datakit').url.template,
      ModelUtil                     = require('fukit').ModelUtil,
      TemplateObjectAttachmentModel = require('model/template.object.attachment.model'),
      SelectAndUploadFilesBehavior  = require('behavior/select.and.upload.files.behavior'),
      DownloadFileOnEventBehavior   = require('behavior/download.file.on.event.behavior'),
      DragAndDropFilesBehavior      = require('behavior/drag.and.drop.files.behavior'),

      AuthorizationBehavior         = require('fukit').AuthorizationBehavior,
      ROLES                         = require('fukit').Roles;

  var AttachmentPointPreviewAnswerView = UIKit.ComponentsContainerView.extend({
    components: function() {
      var previewAnswerView = this;

      return [
        {
          type: UIKit.ComponentsContainerView,
          className: 'attachment point',
          id: 'attachment-point',
          disabled: this.getOption('readonly'),
          behaviors: {
            DragAndDropFilesBehavior: {
              behaviorClass: DragAndDropFilesBehavior,
            },
          },
          components: [
            {
              type: UIKit.Text,
              className: UIKit.Text.prototype.className + ' descriptive',
              text: 'Drop files here to upload',
            },
            {
              type: UIKit.Text,
              className: UIKit.Text.prototype.className + ' descriptive sub',
              text: 'or',
            },
            {
              type: UIKit.Button,
              color: 'primary',
              text: 'Upload File(s)',
              icon: 'upload',
              disabled: this.getOption('readonly'),
              behaviors: {
                AuthorizationBehavior: {
                  enableOnlyWhen: [
                    {
                      roles: [ROLES.EFORM_ATTACHMENT_CREATE],
                    },
                  ],
                  behaviorClass: AuthorizationBehavior,
                },
                BindAndFormatOptionValuesBehavior: {
                  optionValues: {
                    disabled: {
                      formatter: function() {
                        var previewMode = Radio.request('AppKit.controllerService', 'state').get('previewMode');

                        if (this.view.disabled || previewMode) {
                          return true;
                        }
                        return false;
                      },
                    },
                  },
                  behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                },
                SelectAndUploadFilesBehavior: {
                  fineUploaderOptions: function() {
                    var self = this;

                    return {
                      objectProperties: {
                        key: function(fileId) {
                          var key = UUID.generate();
                          var model = new TemplateObjectAttachmentModel({
                            name: this.getFile(fileId).name,
                            parentAttachmentPoint: Radio.request('AppKit.controllerService', 'state').get('primaryId'),
                            attachmentPoint: self.view.model.id,
                            s3FileKey: key,
                          });
                          return ModelUtil.resolvePromise(model.save()).thenReturn(key);
                        },
                      },
                    };
                  },
                  behaviorClass: SelectAndUploadFilesBehavior,
                },
                SaveUploadAnswerOnUploadComplete: {
                  eventName: 'upload:complete',
                  useEventArguments: true,
                  method: function(view, fileIndex, fileName, resp, xhr) {
                    var model = this.view.model;
                    var form = previewAnswerView.getOption('form');
                    var answerValueCollection = form.getAnswerValueCollection(model);
                    var attachmentObject = resp || {};

                    var answerValueModel = answerValueCollection.push({
                      id: attachmentObject.id,
                      value: attachmentObject,
                    });

                    form.triggerBeginEditAnswerEvent(previewAnswerView, model, {
                      answerValueModel: answerValueModel,
                    });
                    form.triggerEndEditAnswerEvent(previewAnswerView, model, {
                      answerValueModel: answerValueModel,
                    });
                  },
                  behaviorClass: BlocKit.InvokeMethodOnEventBehavior,
                },
              },
            },
          ],
        },
        {
          type: BlocKit.BasicTableView,
          form: previewAnswerView.form,
          behaviors: {
            BindAndFormatOptionValuesBehavior: {
              optionValues: {
                visible: {
                  formatter: function() {
                    var attachmentCollection = this.view.form.getAnswerValueCollection(this.view.model);
                    return attachmentCollection.length > 0;
                  },
                },
              },
              behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
            },
          },
          collection: previewAnswerView.form.getAnswerValueCollection(this.model),
          columns: [
            {
              text: 'Filename',
              data: 'value.name',
            },
            {
              text: 'Uploaded By',
              data: 'value.createPerson.fullName',
              formatter: BlocKit.Formatter.empty(),
            },
            {
              text: 'Date Uploaded',
              data: 'value.createDate',
              formatter: BlocKit.Formatter.date('L LT'),
            },
            {
              collapsing: true,
              childView: UIKit.Button,
              previewAnswerView: previewAnswerView,
              childViewOptions: function() {
                var previewAnswerView = this.getOption('previewAnswerView');
                return {
                  color: 'red',
                  inline: true,
                  icon: 'close',
                  stopPropagation: true,
                  previewAnswerView: previewAnswerView,
                  behaviors: {
                    AuthorizationBehavior: {
                      enableOnlyWhen: [
                        {
                          roles: [ROLES.EFORM_ATTACHMENT_DELETE],
                        },
                      ],
                      behaviorClass: AuthorizationBehavior,
                    },
                    BindAndFormatOptionValuesBehavior: {
                      optionValues: {
                        disabled: {
                          formatter: function() {
                            var readonly = this.view.previewAnswerView.getOption('readonly');
                            if (readonly) {
                              return true;
                            }
                            return false;
                          },
                        },
                      },
                      behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                    },
                  },
                  onPress: function() {
                    var previewAnswerView = this.getOption('previewAnswerView');
                    var templateObjectModel = previewAnswerView.model;
                    var answerValueModel = this.model;
                    var answerValueCollection = previewAnswerView.form.getAnswerValueCollection(templateObjectModel);
                    var removedAnswerValueModel = answerValueCollection.remove(answerValueModel);

                    previewAnswerView.form.triggerBeginEditAnswerEvent(previewAnswerView, templateObjectModel, {
                      removedAnswerValueModel: removedAnswerValueModel,
                    });
                    previewAnswerView.form.triggerEndEditAnswerEvent(previewAnswerView, templateObjectModel, {
                      removedAnswerValueModel: removedAnswerValueModel,
                    });
                  },
                };
              },
            },
          ],
          childViewOptions: {
            childViewOptions: {
              attributes: {
                style: 'cursor: pointer;',
              },
            },
            behaviors: {
              DownloadFileOnEventBehavior: {
                fileDownloadUrl: function(answerValueModel) {
                  var attachmentModel = new TemplateObjectAttachmentModel(answerValueModel.get('value'));
                  return attachmentModel.fetchSignedUrl().then(function(model) {
                    return model.get('url');
                  });
                },
                behaviorClass: DownloadFileOnEventBehavior,
              },
            },
          },
          emptyText: 'No attachments.',
        },
      ];
    },
  });

  var AttachmentPointContentview = FormKit.BaseContentView.extend({
    internalViewOptions: FormKit.BaseContentView.extendInternalViewOptions({
      previewAnswerView: function() {
        return {
          type: AttachmentPointPreviewAnswerView,
        };
      },
    }),
  });

  module.exports = AttachmentPointContentview;
});

